import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { SlingoLadderResult } from "slingo/model/results/slingo-ladder-result";
import { SlingoSoundEvent } from "slingo/sound/slingo-sound-events";
import { SlingoRecoveryState } from "slingo/states/slingo-recovery-state";

export class FowlRecoveryState extends SlingoRecoveryState {
    public complete(): void {
        super.complete();

        const ladderResult = gameState.getCurrentGame().getLatestResultOfType(SlingoLadderResult);
        for (let i = 0; i <= ladderResult.total - ladderResult.increase; i++) {
            Services.get(SoundService).event(SlingoSoundEvent.ladder_level_up_N as any, i.toString());
        }
    }
}
